import { CurrencyAmount, ChainId as UniswapSDKChainId } from "@uniswap/sdk-core";
import { ETH_LOGO, ZORA_LOGO } from "ui/src/assets";
import { USDC_ZORA } from "uniswap/src/constants/tokens";
import { Chain as BackendChainId } from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { DEFAULT_NATIVE_ADDRESS_LEGACY, getQuicknodeEndpointUrl } from "uniswap/src/features/chains/evm/rpc";
import {
  NetworkLayer,
  RPCType,
  UniverseChainId
} from "uniswap/src/features/chains/types";
import { ElementName } from "uniswap/src/features/telemetry/constants";
import { zora } from "wagmi/chains";
export const ZORA_CHAIN_INFO = {
  ...zora,
  id: UniverseChainId.Zora,
  sdkId: UniswapSDKChainId.ZORA,
  assetRepoNetworkName: "zora",
  backendChain: {
    chain: BackendChainId.Zora,
    backendSupported: true,
    isSecondaryChain: false,
    nativeTokenBackendAddress: void 0
  },
  blockPerMainnetEpochForChainId: 1,
  // TODO: verify
  blockWaitMsBeforeWarning: 6e5,
  bridge: "https://bridge.zora.energy/",
  docs: "https://docs.zora.co/",
  elementName: ElementName.ChainZora,
  explorer: {
    name: "Zora Explorer",
    url: "https://explorer.zora.energy/"
  },
  helpCenterUrl: void 0,
  infoLink: "https://app.uniswap.org/explore/tokens/zora",
  infuraPrefix: void 0,
  interfaceName: "zora",
  label: "Zora Network",
  logo: ZORA_LOGO,
  networkLayer: NetworkLayer.L2,
  nativeCurrency: {
    name: "Zora ETH",
    symbol: "ETH",
    decimals: 18,
    address: DEFAULT_NATIVE_ADDRESS_LEGACY,
    logo: ETH_LOGO
  },
  pendingTransactionsRetryOptions: void 0,
  rpcUrls: {
    [RPCType.Public]: { http: [getQuicknodeEndpointUrl(UniverseChainId.Zora)] },
    [RPCType.Default]: { http: ["https://rpc.zora.energy/"] },
    [RPCType.Interface]: { http: [getQuicknodeEndpointUrl(UniverseChainId.Zora)] }
  },
  spotPriceStablecoinAmount: CurrencyAmount.fromRawAmount(USDC_ZORA, 1e10),
  stablecoins: [USDC_ZORA],
  statusPage: void 0,
  supportsInterfaceClientSideRouting: false,
  supportsGasEstimates: true,
  supportsV4: true,
  urlParam: "zora",
  wrappedNativeCurrency: {
    name: "Wrapped Ether",
    symbol: "WETH",
    decimals: 18,
    address: "0x4200000000000000000000000000000000000006"
  }
};
